import PageHeader from "@/components/page-header";
import { Timer } from "iconsax-react";
import PreviousEditionsTable from "./previous-editions-table/previous-editions-table";

const PreviousEditionsPage = () => {
  return (
    <>
      <PageHeader
        className="mb-4"
        title="Ediciones anteriores"
        icon={<Timer />}
      />

      <PreviousEditionsTable />
    </>
  );
};

export default PreviousEditionsPage;
